import * as React from 'react';
import * as moment from 'moment';
import ContentBanner from 'modules/content-banner';
import { localizeDate, localizeMonth } from 'utils/localizeTime';
import { TEXT_KEYS } from './base-screen.constants';
import { IBaseScreenProps } from './base-screen.types';
import { translate } from 'components/translate-hoc';

class BaseScreen extends React.Component<IBaseScreenProps> {
    /** "Free Weekend" event has pre-defined duration */
    public getDuration(): JSX.Element | null {
        if (!this.props.platform) {
            return null;
        }
        const { startDate, endDate } = this.props.platform;
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;

        const startMoment: moment.Moment = moment.utc(startDate).local();
        const endMoment: moment.Moment = moment.utc(endDate).local();

        const isSameMonth: boolean = startMoment.isSame(endMoment, 'month');
        const currentKey: string = isSameMonth ? TEXT_KEYS.EVENT_DATES_ONE_MONTH : TEXT_KEYS.EVENT_DATES_TWO_MONTH;

        const localizedStartMonth: string = localizeMonth(startMoment);
        const localizedDates: string = translateKey(currentKey, {
            month: localizedStartMonth,
            startDay: localizeDate(startMoment),
            endDay: localizeDate(endMoment),
            startMonth: localizedStartMonth,
            endMonth: localizeMonth(endMoment)
        });

        return (
            <>
                <br />
                <span>{localizedDates}</span>
            </>
        );
    }
    public getDescription() {
        if (!this.props.platform) {
            return null;
        }
        const { startDate } = this.props.platform;
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;

        const eventAvailabilityKey: string = moment.utc().isBefore(moment.utc(startDate))
            ? TEXT_KEYS.EVENT_PRELOAD_AVAILABLE
            : TEXT_KEYS.EVENT_AVAILABLE;
        return <>{translateKey(eventAvailabilityKey)}</>;
    }
    public render() {
        return (
            <>
                <ContentBanner extraTitle={this.getDuration()} description={this.getDescription()}/>
                {this.props.children}
            </>
        );
    }
}

export default translate()(BaseScreen);
